import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center md:justify-center h-full w-full px-8" }
const _hoisted_2 = { class: "my-2 space-y-2 md:w-1/2 max-md:w-full" }
const _hoisted_3 = { class: "text-xs text-gray-500" }

import { BasicCredentials } from '@/http/login';
import { onBeforeMount, ref } from 'vue';

import Input from '@/components/ui/input/Input.vue';
import Button from '@/components/ui/button/Button.vue';
import { useToast } from '@/components/ui/toast';
import Toaster from '@/components/ui/toast/Toaster.vue';
import { useStore } from 'vuex';
import { AUTHENTICATE, PARTNER_ID, GET_CREDENTIALS as CREDENTIALS } from '@/store';
import { useRouter } from 'vue-router';
import { AuthenticationError } from '@/http/api';
import PasswordInput from './PasswordInput.vue';
import { validateEmail, validatePassword } from '@/lib/formValidation';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginComponent',
  emits: ['TOGGLE_REGISTRATION', 'GO_TO_PARTNER_FORM'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const email = ref('');
const password = ref('');
const { getters, dispatch } = useStore();

const { toast } = useToast();

const router = useRouter();
const onSubmit = async (event: Event) => {
  event.preventDefault();
  if (!(validateEmail(email.value) && validatePassword(password.value))) {
    toast({
      variant: 'destructive',
      title: 'Preencha os dados de acesso',
      description: 'É necessário um e-mail válido e uma senha de 6 dígitos',
    });
    return;
  }
  const requiredLogin: BasicCredentials = {
    email: email.value,
    password: password.value,
  };

  try {
    await dispatch(AUTHENTICATE, requiredLogin);

    if (getters[PARTNER_ID] != undefined) {
      await router.push({ path: '/dashboard' });
    }

    emit('GO_TO_PARTNER_FORM');
  } catch (err) {
    if (err instanceof AuthenticationError) {
      toast({
        title: 'Não foi possível logar',
        description: 'Verifique sua senha e tente novamente',
        variant: 'destructive',
      });
      return;
    }
    toast({
      title: 'O sistema parece estar indisponível',
      description: 'Tente novamente mais tarde',
      variant: 'destructive',
    });
  }
};

onBeforeMount(() => {
  if (getters[CREDENTIALS] === undefined) return;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      class: "w-full h-full",
      onSubmit: onSubmit
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Input, {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            type: "email",
            placeholder: "E-mail"
          }, null, 8, ["modelValue"]),
          _createVNode(PasswordInput, {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            placeholder: "Senha"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(Button, {
          type: "submit",
          class: "my-2 bg-blue-700 md:w-1/2 max-md:w-full rounded-full text-slate-50 text-xs"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Logar ")
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(" Não tem uma conta? "),
          _createElementVNode("a", {
            class: "text-blue-500 cursor-pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('TOGGLE_REGISTRATION')))
          }, "Registre-se")
        ])
      ])
    ], 32),
    _createVNode(Toaster)
  ], 64))
}
}

})